import axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import UserContext from '../../../context/UserContext';
import Button from '../../shared/Button';
import Input from '../../shared/Input';
import Errors from '../../shared/Errors';
import Box from '../../shared/layouts/Box';
import Cluster from '../../shared/layouts/Cluster';
import Labeled from '../../shared/WithLabel';
import LoginContainer from './LoginContainer';
import Flex from "../../shared/layouts/Flex";
import WhiteLabelContext from "../../../context/WhiteLabelContext";
import {useTranslation} from "react-i18next";

const RecoveryCode = () => {
  const { logoutUser } = useContext(UserContext);
  const { platformName } = useContext(WhiteLabelContext);
  const [recoveryCode, setRecoveryCode] = useState(Array(4).fill(''));
  const [errors, setErrors] = useState({});
  const { t } = useTranslation();

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrors({});
    axios
      .post(
        '/multifactor/authenticate',
        { mfa_input: recoveryCode.join('') },
        { headers: { 'Content-Type': 'application/json' },
      })
      .then(() => {
        window.location = '/dashboard';
        // navigate('/dashboard');
      })
      .catch(({ response }) => {
        if (response.status === 401) {
          setErrors({ recovery_code: [t('Herstelcode onbekend')] })
        } else {
          setErrors(response.response.data.errors);
        }
      });
  };

  useEffect(() => {
    axios
      .get('multifactor/choose/recovery-codes')
      .catch(console.error);
  }, []);

  return (
    <LoginContainer width={{ sm: '21.5rem', ml: '27.5rem'}} handleSubmit={handleSubmit} hideUwKluisLogo>
      <Box fontScale="2xl" fontWeight="bold">
        {t('Bevestig jouw inlog')}
      </Box>
      <Box>
        {t('Voor hier een van je jouw voorgegenereerde {{platformName}} herstelcodes in.', {platformName})}
      </Box>
      <Labeled label={t("Voer jouw code in")}>
        <Flex css={{
          '> * + *': {
            marginLeft: '16px',
          },
        }}>
          {recoveryCode.map((value, i) => (
            <Input
              key={i}
              value={value}
              maxLength={4}
              css={{ flex: '40px 1 0' }}
              errors={!!errors?.recovery_code}
              onChange={({ target }) => {
                const newValue = target.value.toUpperCase();
                const nextInput = target.parentElement.nextSibling;
                const goToNext = [newValue.length, target.selectionStart, target.selectionEnd].every(e => e === 4);
                setRecoveryCode([
                  ...recoveryCode.slice(0, i),
                  newValue,
                  ...recoveryCode.slice(i + 1),
                ]);
                if (goToNext && nextInput) nextInput.children[0].focus();
              }}
              onKeyDown={({ key, target }) => {
                if (key === 'Backspace' && target.selectionStart === 0 && target.selectionEnd === 0) {
                  const previousInput = target.parentElement.previousSibling;
                  if (previousInput) previousInput.children[0].focus();
                }
              }}
              onPaste={({ clipboardData }) => {
                const data = clipboardData.getData('Text');
                const matchesRecoveryCode = data.match(/[A-Z0-9]{4} - [A-Z0-9]{4} - [A-Z0-9]{4} - [A-Z0-9]{4}/);

                if (matchesRecoveryCode) {
                  setRecoveryCode(matchesRecoveryCode[0].split(' - '));
                }
              }}
            />
          ))}
        </Flex>
        <Errors errors={errors?.recovery_code} />
      </Labeled>
      <Link
        to="/switch-mfa"
        css={(theme) => ({
          fontSize: theme.fontSizes.s,
          marginTop: theme.space.m,
          textDecoration: 'underline',
          color: theme.colors.primary,
          fontWeight: 'bold',
        })}
      >
        {t('Inloggen op een andere manier')}
      </Link>
      <Cluster mt="xl" display="flex" justifyContent="flex-end" hGap="m">
        <Button
          variant="primary-outline"
          onClick={() => {
            axios({ method: 'get', url: '/logout', data: {} }).then(() => {
              logoutUser();
            });
          }}
        >
          {t('Annuleren')}
        </Button>
        <Button variant="primary" type="submit">
          {t('Inloggen')}
        </Button>
      </Cluster>
    </LoginContainer>
  );
};
export default RecoveryCode;
